import Route from '@ember/routing/route'
import { service } from '@ember/service'
import type RouterService from '@ember/routing/router-service'
import { Product } from 'teacher-ui-client/utils/products'
import type ReadingEggspressDashboardStudentComprehensionLessonProgressRoute from 'teacher-ui-client/reporting/ui-scope/rex/dashboard/student/comprehension-lesson-progress/route'

export interface Params extends Record<string, unknown> {
  pageNumber: number
  perPage: number
  sort: string
}

export default class RexDashboardStudentComprehensionLessonProgressIndexRoute extends Route {
  @service router!: RouterService

  queryParams = {
    pageNumber: {
      replace: true,
      refreshModel: true,
    },
    perPage: {
      replace: true,
      refreshModel: true,
    },
    sort: {
      replace: true,
      refreshModel: true,
    },
  }

  model({ pageNumber, perPage, sort }: Params) {
    const {
      requestScope,
      period,
      fetchComprehensionProgressOverviewReportTask,
      fetchComprehensionProgressPlacementEventsReportTask,
      fetchComprehensionProgressEventsReportTask,
    } = this.modelFor(
      'reporting.ui-scope.rex.dashboard.student.comprehension-lesson-progress',
    ) as ModelFor<ReadingEggspressDashboardStudentComprehensionLessonProgressRoute>

    // Reset the page number for events if either of the parent tasks are running
    if (
      pageNumber !== 1 &&
      (fetchComprehensionProgressOverviewReportTask.isRunning ||
        fetchComprehensionProgressPlacementEventsReportTask.isRunning)
    ) {
      void this.router.transitionTo({ queryParams: { pageNumber: 1 } })
      return {
        fetchComprehensionProgressOverviewReportTask,
        fetchComprehensionProgressPlacementEventsReportTask,
        fetchComprehensionProgressEventsReportTask,
      }
    }

    void fetchComprehensionProgressEventsReportTask
      .perform(Product.REX, sort, { number: pageNumber, size: perPage }, { placement: false }, period, requestScope)
      .catch(() => {})

    return {
      fetchComprehensionProgressOverviewReportTask,
      fetchComprehensionProgressPlacementEventsReportTask,
      fetchComprehensionProgressEventsReportTask,
    }
  }
}
